export default __webpack_public_path__ + "static/media/tripadvisor-logo-black.1ebc78e3.svg";